import { z } from "zod";
import { cursorPageSchema } from "./context.js";
import { taxPolicyVersionSchema } from "./rule-drafts.js";
/** Selector metadata only. Rule content, evidence and governance identities stay private. */
export const calculationRulesetStatusSchema = z.enum(["PUBLISHED", "SUPERSEDED"]);
export const calculationRulesetSortSchema = z.enum(["publishedAt", "version"]);
export const CALCULATION_RULESET_MAX_LIMIT = 200;
export const calculationRulesetOptionSchema = z
    .object({
    id: z.string().uuid(),
    version: z.string().min(1).max(80),
    status: calculationRulesetStatusSchema,
    isActive: z.boolean(),
    policyVersion: taxPolicyVersionSchema.optional(),
})
    .strict()
    .refine((option) => !option.isActive || option.status === "PUBLISHED", {
    message: "Only a currently published ruleset is active",
    path: ["isActive"],
});
export const calculationRulesetOptionsQuerySchema = z
    .object({
    status: z
        .array(calculationRulesetStatusSchema)
        .min(1)
        .max(2)
        .refine((statuses) => new Set(statuses).size === statuses.length, "Statuses must be unique")
        .default(["PUBLISHED", "SUPERSEDED"]),
    limit: z.number().int().min(1).max(CALCULATION_RULESET_MAX_LIMIT).default(50),
    cursor: z.string().min(1).max(1000).optional(),
    sort: calculationRulesetSortSchema.default("publishedAt"),
    dir: z.enum(["asc", "desc"]).default("desc"),
})
    .strict();
export const calculationRulesetOptionsPageSchema = cursorPageSchema
    .extend({
    items: z.array(calculationRulesetOptionSchema).max(CALCULATION_RULESET_MAX_LIMIT),
    totalEstimate: z.number().int().nonnegative(),
})
    .strict();
//# sourceMappingURL=calculation-rulesets.js.map